import React from 'react';
import { Icon } from 'shared-components';
// Import Component Styles
import { Loader as LoaderWrapper } from './styles';

function Loader() {
  return <LoaderWrapper>
    <Icon type="loading" size={35} />
  </LoaderWrapper>;
}

export default Loader;
